import React from 'react';
import {Trans} from 'react-i18next';

export default {
  i18n: [
    {label: 'English', value: 'enu', type: 'en'},
    {label: '日本語', value: 'jpn', type: 'ja'},
    {label: 'Español', value: 'esp', type: 'es'},
    {label: '简体中文', value: 'chs', type: 'cn'},
    {label: '繁體中文', value: 'cht', type: 'tw'},
    {label: 'Français', value: 'fra', i18n: 'fr'},
  ],
  languages: [
    {value: 'id', label: 'Bahasa Indonesia'},
    {value: 'ms', label: 'Bahasa Malaysia'},
    {value: 'de', label: 'Deutsch'},
    {value: 'en', label: 'English'},
    {value: 'es', label: 'Español'},
    {value: 'fr', label: 'Français'},
    {value: 'it', label: 'Italiano'},
    {value: 'nl', label: 'Nederlands'},
    {value: 'pt', label: 'Português'},
    {value: 'ru', label: 'Русский'},
    {value: 'tr', label: 'Türkçe'},
    {value: 'cht', label: '繁體中文'},
    {value: 'chs', label: '简体中文'},
    {value: 'ja', label: '日本語'},
    {value: 'ko', label: '한국어'},
    {value: 'th', label: 'ภาษาไท'},
    {value: 'uk', label: 'Ukraine (Україна)'},
    {value: 'vi', label: 'Vietnamese'},
    {value: 'cs', label: 'Czech'},
    {value: 'hu', label: 'Hungarian'},
    {value: 'pl', label: 'Polish'},
    {value: 'ro', label: 'Romanian'},
    {value: 'bg', label: 'Bulgarian'},
    {value: 'da', label: 'Danmark'},
    {value: 'fi', label: 'Finland'},
    {value: 'nb', label: 'Norwegian'},
    {value: 'sv', label: 'Sweden'},
  ],

  languages2: [
    {value: 'enu', label: 'English', i18n: 'en'},
    {value: 'chs', label: '简体中文', i18n: 'cn'},
    {value: 'cht', label: '繁體中文', i18n: 'tw'},
    {value: 'jpn', label: '日本語', i18n: 'ja'},
    {value: 'fra', label: 'Français', i18n: 'fr'},
    {value: 'esp', label: 'Español', i18n: 'es'},
  ],
  defaultLanguage: [
    {value: 'deu', label: 'Deutsch'},
    {value: 'enu', label: 'English'},
    {value: 'esp', label: 'Español'},
    {value: 'fra', label: 'Français'},
    {value: 'ptb', label: 'Português'},
    {value: 'jpn', label: '日本語'},
    {value: 'cht', label: '繁體中文'},
    {value: 'chs', label: '简体中文'},
    {value: 'kor', label: '한국어'},
    {value: 'ita', label: 'Italian'},
  ],
  chartcolors: {
    0: 'rgba(234,100,112,1)',
    1: 'rgba(246,184,88,1)',
    2: 'rgba(198,213,125,1)',
    3: 'rgba(132,189,110,1)',
    4: 'rgba(148,203,210,1)',
    5: 'rgba(101,171,204,1)',
    6: 'rgba(190,168,200,1)',
    7: 'rgba(246,172,179,1)',
    8: '#ffb03a',
    9: '#ed634c',
    10: '#54a77b',
    11: '#5295d9',
    12: '#70cceb',
    13: '#f4e389',
    14: '#f65670',
    15: '#9ec54c',
    16: '#69b2cd',
    17: '#e9a4c5',
    18: '#4f9167',
    19: '#f7d64e',
  },
  resolutions: [
    {value: '600x900', label: '600x900'},
    {value: '540x810', label: '540x810'},
    {value: '480x560', label: '480x560'},
    {value: '450x675', label: '450x675'},
    {value: '400x600', label: '400x600'},
    {
      value: '360x480',
      label: (
        <Trans i18nKey="u.c.globals.resolutions.recommended">
          360x480 (recommended)
        </Trans>
      ),
    },
    {value: '300x450', label: '300x450'},
  ],
  resolutions4Google: [
    {value: '600x900', label: '600x900'},
    {value: '540x810', label: '540x810'},
    {value: '480x560', label: '480x560'},
    {value: '450x675', label: '450x675'},
    {value: '400x600', label: '400x600'},
    {
      value: '360x480',
      label: (
        <Trans i18nKey="u.c.globals.resolutions.recommended">
          360x480 (recommended)
        </Trans>
      ),
    },
    {value: '320x480', label: '320x480'},
    {value: '300x450', label: '300x450'},
    {value: '300x250', label: '300x250'},
  ],
  mobileResolutions: [
    {value: '1x1', label: '1 : 1'},
    {
      value: '1x1.1',
      label: (
        <Trans i18nKey="u.c.globals.resolution.recommended">
          1 : 1.1 (recommended)
        </Trans>
      ),
    },
    {value: '1x1.2', label: '1 : 1.2'},
    {value: '1x1.3', label: '1 : 1.3'},
    {value: '1x1.4', label: '1 : 1.4'},
    {value: '1x1.5', label: '1 : 1.5'},
    {value: '1x1.6', label: '1 : 1.6'},
    {
      value: 'fullxfull',
      label: (
        <Trans i18nKey="u.c.globals.resolution.fullscreen">fullscreen</Trans>
      ),
    },
  ],
  layouts: [
    {
      value: 'LAYOUT1',
      label: 'p.p.webmodule.configuration.layout.layout1',
      imageUrl:
        'https://plugins-media.makeupar.com/webconsultation/images/bg1.jpg',
    },
    {
      value: 'LAYOUT2',
      label: 'p.p.webmodule.configuration.layout.layout2',
      imageUrl: require('../../assets/images/configuration/layouts/laucher_2_bg.jpg'),
    },
    {
      value: 'LAYOUT3',
      label: 'p.p.webmodule.configuration.layout.layout3',
      imageUrl: require('../../assets/images/configuration/layouts/laucher_3_bg.jpg'),
    },
  ],
  layoutsEyewear: [
    {
      value: 'LAYOUT4',
      label: 'p.p.webmodule.configuration.layout.layout1',
      imageUrl:
        'https://plugins-media.makeupar.com/webconsultation/images/bg1.jpg',
    },
    {
      value: 'LAYOUT2',
      label: 'p.p.webmodule.configuration.layout.layout2',
      imageUrl: require('../../assets/images/configuration/layouts/laucher_2_bg.jpg'),
    },
    {
      value: 'LAYOUT3',
      label: 'p.p.webmodule.configuration.layout.layout3',
      imageUrl: 'https://plugins-media.makeupar.com/smb/images/eyewear/bg.jpg',
    },
  ],
  reflectionImages: [
    {
      value: 'DEFAULT',
      label: (
        <Trans i18nKey="p.e.addoreditframe.frame.design.reflection.image.default">
          Default
        </Trans>
      ),
      imageUrl: 'https://plugins-media.makeupar.com/smb/images/eyewear/1.png',
    },
    {
      value: 'IMAGE_A',
      label: (
        <Trans i18nKey="p.e.addoreditframe.frame.design.reflection.image.a">
          Image A
        </Trans>
      ),
      imageUrl: 'https://plugins-media.makeupar.com/smb/images/eyewear/2.png',
    },
    {
      value: 'IMAGE_B',
      label: (
        <Trans i18nKey="p.e.addoreditframe.frame.design.reflection.image.b">
          Image B
        </Trans>
      ),
      imageUrl: 'https://plugins-media.makeupar.com/smb/images/eyewear/3.png',
    },
    {
      value: 'IMAGE_C',
      label: (
        <Trans i18nKey="p.e.addoreditframe.frame.design.reflection.image.c">
          Image C
        </Trans>
      ),
      imageUrl: 'https://plugins-media.makeupar.com/smb/images/eyewear/4.png',
    },
    {
      value: 'IMAGE_D',
      label: (
        <Trans i18nKey="p.e.addoreditframe.frame.design.reflection.image.d">
          Image D
        </Trans>
      ),
      imageUrl: 'https://plugins-media.makeupar.com/smb/images/eyewear/5.png',
    },
    {
      value: 'IMAGE_E',
      label: (
        <Trans i18nKey="p.e.addoreditframe.frame.design.reflection.image.e">
          Image E
        </Trans>
      ),
      imageUrl: 'https://plugins-media.makeupar.com/smb/images/eyewear/6.png',
    },
  ],
  employeeNumbers: [
    {
      value: 'C050',
      label: (
        <Trans i18nKey="u.c.globals.employee.num.50">1 - 50 employees</Trans>
      ),
    },
    {
      value: 'C100',
      label: (
        <Trans i18nKey="u.c.globals.employee.num.100">51 - 100 employees</Trans>
      ),
    },
    {
      value: 'C200',
      label: (
        <Trans i18nKey="u.c.globals.employee.num.200">
          101 - 200 employees
        </Trans>
      ),
    },
    {
      value: 'C300',
      label: (
        <Trans i18nKey="u.c.globals.employee.num.300">
          201 - 300 employees
        </Trans>
      ),
    },
    {
      value: 'C500',
      label: (
        <Trans i18nKey="u.c.globals.employee.num.500">
          201 - 300 employees
        </Trans>
      ),
    },
    {
      value: 'C999',
      label: (
        <Trans i18nKey="u.c.globals.employee.num.500">
          201 - 500 employees
        </Trans>
      ),
    },
  ],
  businessTypes: [
    {
      value: 'MAKEUP',
      label: <Trans i18nKey="u.c.globals.business.type.makeup">Makeup</Trans>,
    },
    {
      value: 'SKINCARE',
      label: (
        <Trans i18nKey="u.c.globals.business.type.skincare">Skincare</Trans>
      ),
    },
    {
      value: 'COLORLENS',
      label: (
        <Trans i18nKey="u.c.globals.business.type.color.lenses">
          Color Lenses
        </Trans>
      ),
    },
    {
      value: 'EYEWEAR',
      label: <Trans i18nKey="u.c.globals.business.type.eyewear">Eyewear</Trans>,
    },
    {
      value: 'HAIRRELATED',
      label: (
        <Trans i18nKey="u.c.globals.business.type.hair.related">
          Hair Related
        </Trans>
      ),
    },
    {
      value: 'JEWELRY',
      label: <Trans i18nKey="u.c.globals.business.type.jewelry">Jewelry</Trans>,
    },
    {
      value: 'OTHERS',
      label: <Trans i18nKey="u.c.globals.business.type.others">Others</Trans>,
    },
  ],
  cleverbridge: {
    cbId: '138ad304',
    pfId: '1628',
  },
  roles: [
    {
      value: 'role-001',
      label: (
        <Trans i18nKey="p.g.t.staffs.role.module.configuration">
          Module Configuration
        </Trans>
      ),
      order: 1,
    },
    {
      value: 'role-003',
      label: <Trans i18nKey="p.g.t.staffs.role.analytics">Analytics</Trans>,
      order: 3,
    },
    {
      value: 'role-006',
      label: (
        <Trans i18nKey="c.l.sidebar.1110.upgrade.title">
          SKU/Makeup Products
        </Trans>
      ),
      order: 0,
    },
    {
      value: 'role-007',
      label: (
        <Trans i18nKey="p.g.t.staffs.role.api.integration">
          API Integration
        </Trans>
      ),
      order: 2,
    },
  ],
  eyewearRoles: [
    {
      value: 'role-001',
      label: (
        <Trans i18nKey="p.g.t.staffs.role.module.configuration">
          Module Configuration
        </Trans>
      ),
      order: 1,
    },
    {
      value: 'role-003',
      label: <Trans i18nKey="p.g.t.staffs.role.analytics">Analytics</Trans>,
      order: 3,
    },
    {
      value: 'role-006',
      label: (
        <Trans i18nKey="c.l.sidebar.1110.frame.title">
          Frame/Eyewear Products
        </Trans>
      ),
      order: 0,
    },
    {
      value: 'role-007',
      label: (
        <Trans i18nKey="p.g.t.staffs.role.api.integration">
          API Integration
        </Trans>
      ),
      order: 2,
    },
  ],
  expiredAvailableMenus: [1010, 10000, 10100, 10110, 8000, 8100, 8120],
  paypal: {
    dashboard: 'https://www.paypal.com/myaccount/summary/',
  },
  addon: {
    sku: {
      productId: 220331,
      name: 'Additional 50 SKUs',
    },
    look: {
      productId: 220332,
      name: 'Additional 5 Looks',
    },
  },
};
